namespace TabAurous.OMS {
    export interface RewardsMasterRow {
        RMasterId?: number;
        RewardCode?: string;
        ExchangeRate?: number;
        MobilePoints?: number;
        EmailPoints?: number;
        ReferencePoints?: number;
        PurchaseValue?: number;
        ProductWise?: boolean;
        CustomerCategoryId?: string;
        RewardsDetails?: RewardsDetailsRow[];
    }

    export namespace RewardsMasterRow {
        export const idProperty = 'RMasterId';
        export const nameProperty = 'RewardCode';
        export const localTextPrefix = 'OMS.RewardsMaster';
        export const deletePermission = 'Masters:Rewards:Delete';
        export const insertPermission = 'Masters:Rewards:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:Rewards:Edit';

        export declare const enum Fields {
            RMasterId = "RMasterId",
            RewardCode = "RewardCode",
            ExchangeRate = "ExchangeRate",
            MobilePoints = "MobilePoints",
            EmailPoints = "EmailPoints",
            ReferencePoints = "ReferencePoints",
            PurchaseValue = "PurchaseValue",
            ProductWise = "ProductWise",
            CustomerCategoryId = "CustomerCategoryId",
            RewardsDetails = "RewardsDetails"
        }
    }
}
